// Copyright (c) 2017 Deere & Company

import './index.scss';
import * as actionCreators from '../../action-creators';
import ReimbursementSummaryAside from './reimbursement-summary-aside';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = (state, ownProps) => ({
    isInitialLoad: state.reimbursementSummary.summary.isInitialLoad,
    leadAccounts: state.reimbursementSummary.summary.leadAccounts,
    pathName: ownProps.pathName,
    queryParams: ownProps.queryParams,
    selectedLeadAccount: state.reimbursementSummary.summary.selectedLeadAccount,
    selectedPostingDate: state.reimbursementSummary.summary.selectedPostingDate,
    selectedValue: state.reimbursementSummary.summary.selectedValue
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ReimbursementSummaryAside);



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-aside/index.js